import comp from "./StudentAlertsWrapper";
export default comp;
